import React, { useEffect } from 'react';
import {Modal, StyleSheet, View} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {getRootModal} from '../../actions/RootModal';
import {selectRootModal} from '../../selectors/ModalSelector';
import { showAlert } from '../../actions/AlertActions';
import { useTranslation } from 'react-i18next';

export default function RootModal() {
  const dispatch = useDispatch();
  const {isVisible, type} = useSelector(state => selectRootModal(state));
  const { t } = useTranslation()


  return (
    <Modal
      animationType="slide"
      transparent={true}
      visible={isVisible}
      onRequestClose={() => {
        dispatch(getRootModal({isVisible: false, type: ''}));
      }}>
      </Modal>
  );
}
